const e = {
  country_code: "US",
  lang_code: "en",
  locale: "en-US",
  env: "unknown",
  country_default_language: "en",
  default_country: "US",
  default_language: "en",
  supported_countries: ["US"],
  available_languages: ["en"],
  service_name: "pw-tracking"
};
export {
  e as DefaultEnvironment
};
